var _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuoteLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_3",
    x: "0px",
    y: "0px",
    viewBox: "0 0 480.5 360.9",
    enableBackground: "new 0 0 480.5 360.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#03436C",
    d: "M217.7,143.4c-20.2-21.8-49-35.5-81-35.5V34.3c0,0-110.3,65.4-110.3,183.9c0,60.9,49.4,110.3,110.3,110.3 c35.4,0,66.9-16.7,87.1-42.7c-13.2-19.3-20.9-42.6-20.9-67.6C202.9,192.7,207.9,167.5,217.7,143.4z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#03436C",
    d: "M323.2,328.5c60.9,0,110.3-49.4,110.3-110.3s-49.4-110.3-110.3-110.3V34.3c0,0-110.3,65.4-110.3,183.9 C212.9,279.1,262.3,328.5,323.2,328.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteLeft);
export default __webpack_public_path__ + "static/media/quote_left.0624c49bd4a3d822c04c50090e8fa736.svg";
export { ForwardRef as ReactComponent };